import React from "react";
import { Task } from "../../../models/Task";
import { useTask } from "../../../contexts/TaskContext";
import { Table, TableBody } from "../../../design/table";
import { Heading, Subheading } from "../../../design/heading";
import TaskListItem from "../../../components/TaskComponent/components/TaskListItem";
import TaskButton from "../../../components/TaskButton";
import { Card } from "../../../design/card";

interface Props {}

const CustodyTasks: React.FC<Props> = ({}) => {
  const { tasks } = useTask();
  const filteredTasks = tasks.filter((task) => task.type === "custody");
  return (
    <Card>
      <div className="flex items-center justify-between">
        <Heading level={5}>Tasks</Heading>
        <TaskButton taskType="custody" />
      </div>
      {filteredTasks.length === 0 && (
        <Subheading className="mt-2 text-gray-500">
          No custody tasks available.
        </Subheading>
      )}
      <Table>
        <TableBody>
          {filteredTasks.map((task) => (
            <TaskListItem key={task._id} task={task} />
          ))}
        </TableBody>
      </Table>
    </Card>
  );
};

export default CustodyTasks;
